// extracted by css-extract-rspack-plugin
export default {"issueTypeTitleRow":"IssueTypePickerBase-module__issueTypeTitleRow__fgtAm","pinnedFieldsBadge":"IssueTypePickerBase-module__pinnedFieldsBadge___lwhk"};